function SpookySwapRouter(){
	return '0xF491e7B69E4244ad4002BC14e878a34207E38c29';
}
function SpiritSwapRouter(){
	return '';
}

function fantomMasterchefs(){
	return [
		'0x67ac0F693C80a37c5a9C2e943e05668615B4Dbeb', //wftm firefly
		'0xEc28a9708c94605AF291f6De29f291dF74877198', //usdc firefly
	];
}

function ethVaults(){
	return [
		'0xdA816459F1AB5631232FE5e97a05BBBb94970c95', //newdai
		'0xa354F35829Ae975e850e23e9615b11Da1B3dC4DE', //newusdc
		'0xa258C4606Ca8206D8aA700cE2143D7db854D168c', //newweth
		'0x7Da96a3891Add058AdA2E826306D812C638D87a7', //newusdt
		'0xA696a63cc78DfFa1a63E9E50587C197387FF6C7E', //newwbtc
		'0xdb25cA703181E7484a155DD612b06f57E12Be5F0', //newyfi
		'0x0F6121fB28C7C42916d663171063c62684598f9F']; //hbtc
}

function ftmVaults(){
	return [
		'0x0DEC85e74A92c52b7F708c4B10207D9560CEFaf0', //wftm
		'0xEF0210eB96c7EB36AF8ed1c20306462764935607']; //usdc
}

function fchad(){
	return '0xC0E2830724C946a6748dDFE09753613cd38f6767';
}

function solidlyRouterAddress(){
	return '0xa38cd27185a464914D3046f0AB9d43356B34829D';
}
function spookyRouterAddress(){
	return '0xF491e7B69E4244ad4002BC14e878a34207E38c29';
}
function sex(){
	return '0xD31Fcd1f7Ba190dBc75354046F6024A9b86014d7';
}
function solidsex(){
	return '0x41adAc6C1Ff52C5e27568f27998d747F7b69795B';
}
function solid(){
	return '0x888EF71766ca594DED1F0FA3AE64eD2941740A20';
}
function wftm(){
	return '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83';
}
function daiFantom(){
	return '0x8D11eC38a3EB5E956B052f67Da8Bdc9bef8Abf3E';
}
function solidexLpDepositer(){
	return '0x26E1A0d851CF28E697870e1b7F053B605C8b060F';
}

function solidsexsolidlp(){
	return '0x62E2819Dd417F3b430B6fa5Fd34a49A377A02ac8';
}
function sexwftmlp(){
	return '0xFCEC86aF8774d69e2e4412B8De3f4aBf1f671ecC';
}
function solidexStakingRewardsAddress(){
	return '0x7FcE87e203501C3a035CbBc5f0Ee72661976D6E1';
}


export {sex, solid,spookyRouterAddress, solidexStakingRewardsAddress, daiFantom, solidlyRouterAddress, solidsex,wftm, solidsexsolidlp, SpiritSwapRouter, SpookySwapRouter, fantomMasterchefs, ftmVaults, ethVaults, fchad, solidexLpDepositer, sexwftmlp};